import { ServiceGroups } from './serviceGroups';
import { HowWeWork } from './howWeWork';
import { Technologies } from './technologies';

export const components = {
  services: ServiceGroups,
  how_we_work: HowWeWork,
  tech_stack: Technologies,
  
}